import React, { useEffect } from 'react';
import {
  Button,
  Chip,
  Card,
  Typography,
  Accordion,
  Grid,
  AccordionSummary,
  AccordionDetails,
  Box,
  TextField,
  Badge,
} from '@mui/material';
import './WfhStatusCard.css';
import { DialogBoxComponent } from '../DialogBox/DialogBoxCard';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import {
  WfhStatusType,
  CANCEL_BUTTON_TEXT,
  WfhStatusButton,
  SHOW_NOTIFICATION,
} from '../../constants';
import { useLocation } from 'react-router-dom';
import ShowWfhStatus from './WfhStatus';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { applyWFH, getWfhTaskForManager } from '../../services/WFHService';
import moment from 'moment';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FlakyOutlinedIcon from '@mui/icons-material/FlakyOutlined';
import { useDispatch, useSelector } from 'react-redux';
import KeycloakService from '../../services/KeycloakService';
import { wfhType } from '../../pages/WFH/TaskConstants';
import { getUserProjects } from '../../services/UserService';
import WFHTimingsDropdown from './WfhTimingsDropdown';
import { withStyles } from '@mui/styles';

const WfhStatusCardComponent = (props) => {
  const {
    wfh,
    wfhStatus,
    toggleEditOpen,
    isManagerOrAdmin,
    updateApplication,
    getWfhList,
    setPage,
    setPageNo,
    setRefresh,
    refresh,
  } = props;
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  const [expanded, setExpanded] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [dialogContent, setDialogContent] = React.useState();
  const [confirmText, setConfirmText] = React.useState();
  const [comment, setComment] = React.useState();
  const dispatch = useDispatch();
  const [userProjects, setUserProjects] = React.useState([]);
  const [taskData, setTaskData] = React.useState([]);
  const currentUserId = () => KeycloakService.getUserDetail();

  const cardState = useSelector((state) => state.cardState);

  useEffect(() => {
    setExpanded(cardState.expand);
  }, [cardState]);

  const getWfhTasks = async () => {
    if (
      wfh.applicationDTO.status === 'APPROVED' ||
      wfh.applicationDTO.status === 'TASK_PENDING' ||
      wfh.applicationDTO.status === 'TASK_APPROVED'
    ) {
      const task = await getWfhTaskForManager(
        currentUserId(),
        wfh.applicationDTO.id,
      );
      setTaskData(task?.data?.data?.content);
    }
  };

  useEffect(() => {
    getWfhTasks();
    getProjectsList();
  }, [location]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const getWfhRange = () => {
    let startDate;
    let endDate;

    if (!isManagerOrAdmin) {
      startDate = wfh.startDate;
      endDate = wfh.endDate;
    } else {
      startDate = wfh.applicationDTO.startDate;
      endDate = wfh.applicationDTO.endDate;
    }
    if (startDate === endDate) {
      return <>{moment(startDate).format('DD MMM YYYY')}</>;
    } else {
      return (
        <>
          {moment(startDate).format('DD MMM YYYY')} to{' '}
          {moment(endDate).format('DD MMM YYYY')}
        </>
      );
    }
  };

  const handleClose = () => {
    setComment(null);
    setOpen(false);
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleOnConfirm = () => {
    let templateApplicationResponse = {
      applicationDTO: {
        type: wfh.applicationDTO.type,
        id: wfh.id,
        employeeId: wfh.applicationDTO.employeeId,
        startDate: wfh.applicationDTO.startDate,
        endDate: wfh.applicationDTO.endDate,
        reason: wfh.applicationDTO.reason,
        status: wfh.applicationDTO.status,
        isUpdatedByAdmin: wfh.applicationDTO.isUpdatedByAdmin,
        isUpdatedByHr: false,
        leaveId: wfh.applicationDTO.leaveId,
      },
      id: wfh.id,
      status: ' ',
      comments: !comment ? 'No comments' : comment,
      approverId: currentUserId(),
      isUpdatedByHr: false,
      type: 'WFH',
    };
    if (confirmText === 'Reject') {
      templateApplicationResponse = {
        ...templateApplicationResponse,
        status: 'REJECTED',
      };
    } else if (confirmText === 'Approve') {
      templateApplicationResponse = {
        ...templateApplicationResponse,
        status: 'APPROVED',
      };
    }
    updateApplication(templateApplicationResponse);
    setComment(null);
    setOpen(false);
  };

  const cancelWfhPayload = () => {
    return {
      id: wfh.id,
      employeeId: currentUserId(),
      status: 'CANCELLED',
    };
  };

  const getProjectsList = async () => {
    const projectData = await getUserProjects(currentUserId(), '');
    if (projectData.isError == false) {
      setUserProjects(projectData.data.content);
    }
    if (projectData.status !== 200) {
      dipatchNotification(projectData.type, projectData.message);
    }
  };

  const cancelWfh = async () => {
    const cancelledWfhPayload = cancelWfhPayload();
    const wfhResponse = await applyWFH(cancelledWfhPayload);
    dipatchNotification(wfhResponse.type, wfhResponse.message);
    if (wfhResponse.isError === false) {
      setOpen(false);
      getWfhList();
      setPage(1);
      setPageNo(0);
      setRefresh(!refresh);
    }
  };

  const StyledBadge = withStyles((theme) => ({
    badge: {
      backgroundColor: '#b35900',
      color: 'white',
    },
  }))(Badge);

  return (
    <div>
      {loader ? (
        <Stack>
          <Typography variant="h1">
            {<Skeleton sx={{ height: '9rem' }} />}
          </Typography>
        </Stack>
      ) : (
        <Card variant="outlined" sx={{ mb: 2 }}>
          <div className="wfh-status-container pb-0">
            <div className="space-between-container">
              <Typography sx={{ width: '30%' }} variant="h6">
                {location.pathname !== '/user-manage'
                  ? wfhType(wfh.type)
                  : wfh.empName}
              </Typography>
              <Typography sx={{ width: '40%', textAlign: 'center' }}>
                <CalendarMonthRoundedIcon
                  fontSize="small"
                  className="mr-1 mt-n1"
                />
                {getWfhRange()}
              </Typography>
              <Box sx={{ width: '30%', textAlign: 'right' }}>
                <Chip
                  sx={{ marginRight: 1.5 }}
                  label={wfhStatus}
                  color={
                    wfhStatus === WfhStatusType.APPROVED
                      ? 'success'
                      : wfhStatus === WfhStatusType.REJECTED
                        ? 'error'
                        : 'warning'
                  }
                  size="small"
                  variant="outlined"
                />
              </Box>
            </div>
            {location.pathname === '/user-manage' ||
            location.pathname === '/hr-WFH' ? (
              <Box
                sx={{
                  display: 'flex',
                  marginTop: 1,
                  marginRight: { xs: 0, md: 3 },
                  justifyContent: 'center',
                  marginBottom: 2,
                  width: '100%',
                  flexDirection: { xs: 'column', md: 'row', sm: 'column' },
                }}
              >
                <Chip
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '2px',
                      }}
                    >
                      <Box sx={{ marginRight: '20px' }}>
                        <Typography variant="body3">
                          WFH taken in Year :
                        </Typography>
                      </Box>
                      <StyledBadge
                        badgeContent={wfh?.ytdLeavesTaken?.toString()}
                        sx={{ marginRight: '10px' }}
                      />
                    </Box>
                  }
                  size="small"
                  sx={{
                    color: '#663300',
                    height: '30px',
                    marginRight: { xs: 0, md: 5 },
                    marginBottom: { xs: 1, md: 0 },
                  }}
                  variant="outlined"
                />
                <Chip
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '2px',
                      }}
                    >
                      <Box sx={{ marginRight: '20px' }}>
                        <Typography variant="body3">
                          WFH taken in Quarter :
                        </Typography>
                      </Box>
                      <StyledBadge
                        badgeContent={wfh?.qtdLeavesTaken?.toString()}
                        sx={{ marginRight: '10px' }}
                      />
                    </Box>
                  }
                  size="small"
                  sx={{
                    color: '#663300',
                    height: '30px',
                    marginRight: { xs: 0, md: 5 },
                    marginBottom: { xs: 1, md: 0 },
                  }}
                  variant="outlined"
                />
                <Chip
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '2px',
                      }}
                    >
                      <Box sx={{ marginRight: '20px' }}>
                        <Typography variant="body3">
                          WFH taken in Month :
                        </Typography>
                      </Box>
                      <StyledBadge
                        badgeContent={wfh?.mtdLeavesTaken?.toString()}
                        sx={{ marginRight: '10px' }}
                      />
                    </Box>
                  }
                  size="small"
                  sx={{
                    color: '#663300',
                    height: '30px',
                    marginRight: { xs: 0, md: 0 },
                    marginBottom: { xs: 1, md: 0 },
                  }}
                  variant="outlined"
                />
              </Box>
            ) : (
              ''
            )}
            <div className="flex-center-container">
              <div className="space-between-container">
                <DialogBoxComponent
                  open={open}
                  handleClose={handleClose}
                  confirmText={confirmText}
                  cancelText={'Close'}
                  content={dialogContent}
                  onConfirm={
                    confirmText === 'Confirm' ? cancelWfh : handleOnConfirm
                  }
                  onCancel={handleClose}
                  component={
                    <TextField
                      id="outlined-multiline-static"
                      label="Comment"
                      multiline
                      rows={4}
                      sx={{ mx: 1.2 }}
                      value={comment}
                      onChange={handleCommentChange}
                    />
                  }
                  icon={<FlakyOutlinedIcon color="primary" />}
                />
                {location.pathname === '/user-manage' ? (
                  <>
                    <Button
                      variant="outlined"
                      size="small"
                      color="error"
                      sx={{ px: 3 }}
                      disabled={
                        (wfh.applicationDTO.isUpdatedByAdmin &&
                          !KeycloakService.hasRole(['hr'])) ||
                        wfh.status == 'REJECTED'
                      }
                      hidden={wfh.applicationDTO.status == 'CANCELLED'}
                      onClick={() => {
                        setOpen(true);
                        setConfirmText('Reject');
                        setDialogContent(
                          'Are you sure, you want to reject this application?',
                        );
                      }}
                    >
                      {wfh.status == 'REJECTED'
                        ? WfhStatusButton.REJECTED
                        : WfhStatusButton.REJECT}
                    </Button>

                    <div className="wfh-spacer"></div>
                    <Button
                      variant="outlined"
                      size="small"
                      color="success"
                      sx={{ px: 3 }}
                      disabled={
                        (wfh.applicationDTO.isUpdatedByAdmin &&
                          !KeycloakService.hasRole(['hr'])) ||
                        wfh.status === 'APPROVED' ||
                        wfh.status === 'TASK_PENDING' ||
                        wfh.status === 'TASK_APPROVED'
                      }
                      hidden={wfh.applicationDTO.status == 'CANCELLED'}
                      onClick={() => {
                        setOpen(true);
                        setConfirmText('Approve');
                        setDialogContent(
                          'Are you sure, you want to approve this application?',
                        );
                      }}
                    >
                      {wfh.status === 'APPROVED' ||
                      wfh.status === 'TASK_PENDING' ||
                      wfh.status === 'TASK_APPROVED'
                        ? WfhStatusButton.APPROVED
                        : WfhStatusButton.APPROVE}
                    </Button>
                  </>
                ) : (
                  <>
                    <div className="space-between-container">
                      <Button
                        variant="outlined"
                        size="small"
                        color="error"
                        sx={{ px: 3 }}
                        onClick={() => {
                          setOpen(true);
                          setConfirmText('Confirm');
                          setDialogContent(
                            'Are you sure, you want to cancel this application?',
                          );
                        }}
                      >
                        {CANCEL_BUTTON_TEXT}
                      </Button>
                      <div className="wfh-spacer"></div>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ px: 3 }}
                        onClick={() => {
                          toggleEditOpen(wfh);
                        }}
                      >
                        {WfhStatusButton.RESCHEDULE}
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>{' '}
            {location.pathname === '/user-manage' &&
            wfh.applicationDTO.status != 'CANCELLED' &&
            wfh.applicationDTO.isUpdatedByAdmin &&
            !KeycloakService.hasRole(['hr']) ? (
              <Typography
                sx={{
                  marginTop: 1,
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '12px',
                }}
              >
                <InfoOutlinedIcon color="info" sx={{ fontSize: '13px' }} />{' '}
                {`Application already ${wfh.applicationDTO.status.toLowerCase()} by HR`}
              </Typography>
            ) : (
              ''
            )}
            <div>
              <Accordion
                expanded={expanded}
                onChange={() => setExpanded(!expanded)}
                disableGutters
                elevation={0}
                sx={{ width: '100%' }}
              >
                <Grid
                  className="wfh-container pb-0 pt-0"
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >
                  <AccordionSummary expandIcon={<KeyboardArrowDownIcon />} />
                </Grid>
                <Grid
                  className="wfh-container pb-0 pt-0"
                  sx={{ width: '100%' }}
                >
                  <AccordionDetails className="p-0">
                    <Typography variant="body1" className="mt-1 mb-3">
                      {location.pathname === '/user-manage'
                        ? wfh.applicationDTO.reason
                        : wfh.reason}
                    </Typography>

                    {location.pathname === '/user-manage' ? (
                      expanded &&
                      wfhStatus !== 'APPROVED' &&
                      wfhStatus !== 'TASK_PENDING' &&
                      wfhStatus !== 'TASK_APPROVED' ? (
                        <>
                          <Typography variant="body1" className="mt-1 mb-1">
                            <strong>Approval Status:</strong>
                          </Typography>
                          {wfh.approverList.map((managerResponse) => (
                            <ShowWfhStatus
                              managerResponse={managerResponse}
                              key={managerResponse.id}
                              rows={rows}
                              setRows={setRows}
                              closeWfhStatus={setExpanded}
                            />
                          ))}
                        </>
                      ) : expanded &&
                        (wfhStatus === 'APPROVED' ||
                          wfhStatus === 'TASK_PENDING' ||
                          wfhStatus === 'TASK_APPROVED') &&
                        taskData.length == 0 ? (
                        <>
                          <Typography variant="body1" className="mt-1 mb-1">
                            <strong>Approval Status:</strong>
                          </Typography>
                          {wfh.approverList.map((managerResponse) => (
                            <ShowWfhStatus
                              managerResponse={managerResponse}
                              key={managerResponse.id}
                              rows={rows}
                              setRows={setRows}
                              closeWfhStatus={setExpanded}
                            />
                          ))}
                        </>
                      ) : expanded && taskData.length > 0 ? (
                        <Box sx={{ mb: '1rem' }}>
                          <Typography variant="body1" className="mt-1 mb-1">
                            <strong>Tasks:</strong>
                          </Typography>
                          <WFHTimingsDropdown
                            taskData={taskData}
                            setTaskData={setTaskData}
                            wfh={wfh}
                            userProjects={userProjects}
                            isManagerOrAdmin={isManagerOrAdmin}
                            refreshPage ={refresh}
                            setRefreshPage = {setRefresh}
                          />
                        </Box>
                      ) : (
                        ''
                      )
                    ) : (
                      expanded && ''
                    )}
                  </AccordionDetails>
                </Grid>
              </Accordion>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
};

export default WfhStatusCardComponent;
